import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import fire from "./Firebase";
import "../App.css";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";

function Certitry() {
  const conponentPDF = useRef();
  const [usercertificate, setusercertificate] = useState([]);

  useEffect(() => {

    fire.child(`excelcerti/${sessionStorage.getItem("lastname2")}`).on("value", (sna) => {
        setusercertificate([sna.val()]);
      });
  }, []);
  const generatePDF2 = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => toast("Data saved in PDF"),
  });
  
  return (
    <div>
      {/* <Header />
      {usercertificate.map((all) => {
        return (
          <>
            <div className="print">
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "20px",
                  textalign: "center",
                  border: "10px solid #787878",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    padding: "20px",
                    textalign: "center",
                    border: "5px solid #787878",
                    backgroundColor: "lightsalmon",
                  }}
                >
                  <center>
                    {" "}
                    <div>HR SCHOOL</div>
                    <hr class="accessory" />
                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                      CERTIFICATE OF COMPLETION
                    </span>{" "}
                    <br />
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      <i>CERTIFIED {all.Field} SPECIALIST</i>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontSize: "18px" }}>
                      <b>THIS IS TO CERTIFY THAT</b>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontsize: "20px" }}>
                      <b>
                        NAME :- {all.Gender}. {all.Name}{" "}
                      </b>
                    </span>{" "}
                    <br />
                    <span style={{ fontsize: "20px" }} class="father">
                      <b>FATHER NAME :- {all.Father}</b>
                    </span>
                    <br />
                    <span style={{ fontsize: "20px" }}>
                      <b>COURSE DURATION :- {all.Course}</b>
                    </span>{" "}
                    <br />
                    <span style={{ fontsize: "20px" }} class="father">
                      <b>COURSE NAME :- {all.Coursename}</b>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontsize: "25px" }}>
                      <i>
                        THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE CAN
                        TAKE IT AWAY FROM YOU.
                      </i>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontWeight: "bold" }}>
                      HAS SUCCESSFULLY COMPLETED THE {all.Coursename} COURSE
                      WITH HR SCHOOL
                    </span>{" "}
                    <br />
                    <br />
                    <span style={{ fontsize: "20px" }}>
                      WITH SCORE OF <b>{all.grade}</b>
                    </span>
                    <br />
                    <span style={{ fontsize: "25px" }}>
                      <i>DATED</i>
                    </span>
                    <br />
                    <span style={{ fontsize: "30px" }}>
                      START DATE :- {all.startdate}/{all.startmonth}/
                      {all.startyear}
                    </span>{" "}
                    <br />
                    <span style={{ fontsize: "30px" }}>
                      END DATE :- {all.enddate}/{all.endmonth}/{all.endyear}
                    </span>
                    <br />
                    <br />
                    <span style={{ fontsize: "25px" }} class="website">
                      <i>www.hrschool.com</i>
                    </span>
                    <br />
                  </center>
                </div>
              </div>
              <center>
                {" "}
                <br />
                <button onClick={() => generatePDF2(all)}>
                  Convert In PDF
                </button>
              </center>
            </div>
          </>
        );
      })} */}
    </div>
  );
}

export default Certitry;
